import { api } from '@/src/shared/lib/api'

export async function userPhotosGet<ApiResponse>() {
  const url = api.appURL(`user/photos`)
  url.searchParams.append('add_avatar', String(true))
  const response = await api.get<ApiResponse>(url, {})
  return api.parseRespone<ApiResponse>(response)
}
